import member from "./member";
import sidebar from "./sidebar";
import searchFilter from "./searchFilter";
import skillPath from "./skillPath"

export default {
    sidebar,
    member,
    searchFilter,
    skillPath
}